import { Box, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { useWindowSize } from '../../hooks/use-window-size';
import VdpImageList from './vdp-image-list';
import Exterior360 from '../../sections/exterior-360/exterior-360';
import { useDispatch, useSelector } from 'react-redux';
import {
  carHotSpotEnableSet,
  getActiveTab,
  getCar360Loaded,
  getCarHotSpotCardOpen,
  getCarHotSpotEnable,
  getCarImageRatio,
  getCarStatus,
} from '../../store/car-slice';
import HotspotDialog from '../../sections/hotspot/hotspot-dialog';
import Rotate360 from './rotate-360';
import CustomHotspotButton from '../../components/button/custom-hotspot-button';
import FullscreenButton from '../../sections/buttons/fullscreen-button';

export default function CAR360() {
  const carHotSpotEnable = useSelector(getCarHotSpotEnable);
  const carHotSpotCardOpen = useSelector(getCarHotSpotCardOpen);
  const car360Loaded = useSelector(getCar360Loaded);
  const activeTab = useSelector(getActiveTab);
  const dispatch = useDispatch();

  const [isHovered, setIsHovered] = useState(false);

  // Hook
  const { width, height } = useWindowSize();

  const aspectRatio = useSelector(getCarImageRatio);

  const carStatus = useSelector(getCarStatus);

  const handleChange = () => {
    dispatch(carHotSpotEnableSet(carHotSpotEnable ? false : true));
  };

  const powerByDrivee = car360Loaded && carStatus === 'VDP' && (
    <Box
      component={'span'}
      onClick={() => window.open('https://drivee.ai/', '_blank')}
      sx={{
        margin: 'auto',
        position: 'absolute',
        bottom: '6%',
        right: 5,
        textAlign: 'center',
        cursor: 'pointer',
        display: 'flex',
      }}
    >
      <Box
        alt="view 360"
        component="img"
        id="drivee-watermark-logo"
        loading="lazy"
        onMouseEnter={() => setIsHovered(true)}
        onMouseOut={() => setIsHovered(false)}
        src={isHovered ? '/360-powered-by-drivee.svg' : '/drivee-logo.webp'}
        sx={{
          transition: '0.1s all ease-in-out',
          height: {
            xs: 20,
            md: 20,
            xl: 30,
          },
          maxWidth: '100%',
        }}
      />
    </Box>
  );

  const hotspotCard = car360Loaded && carStatus === 'VDP' && (
    <Box
      sx={{
        margin: 'auto',
        position: 'absolute',
        bottom: '6%',
        left: 5,
        textAlign: 'center',
      }}
    >
      <CustomHotspotButton checked={carHotSpotEnable} onChange={handleChange} />
    </Box>
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: width / height > aspectRatio ? 'row-reverse' : 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        gap: 1,
      }}
    >
      <Box
        className="animate-fade"
        sx={{
          position: 'relative',
          display: 'flex',
          maxWidth: width / height > aspectRatio ? 'fit-content' : '100%',
          maxHeight: 'fit-content',
          ...(width / height > aspectRatio
            ? { width: '100%' }
            : { height: '100%' }),
          flex: 1,
          overflow: 'auto',
          justifyContent: 'center',
        }}
      >
        {car360Loaded && <FullscreenButton />}
        {carHotSpotCardOpen && <HotspotDialog />}
        {activeTab === 'exterior' && <Exterior360 />}
        {activeTab === 'exterior' && <Rotate360 />}
        {hotspotCard}
        {powerByDrivee}
      </Box>

      {carStatus === 'VDP' && car360Loaded && <VdpImageList />}
    </Box>
  );
}
